var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"text-center pt-4"},[_c('br'),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":150}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }